/**
 * Supabase Client - Gobernanza COPARMEX
 * v2.2.0-supabase-env-strict
 */
import { createClient } from '@supabase/supabase-js';

// SEC-005: Separación estricta de entornos.
// Se leen únicamente desde import.meta.env sin fallbacks a credenciales de producción hardcodeadas.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validación estricta para prevenir la inicialización de un cliente nulo o mal configurado
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    if (import.meta.env.DEV) {
        console.error(
            '[SUPABASE_ENV_ERROR]: Falta la configuración de variables de entorno de Supabase.\n' +
            'Asegúrese de definir VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY en su archivo .env o .env.local.'
        );
    }
    throw new Error('Configuración de Supabase no definida en las variables de entorno del sistema.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
